import { render } from "./NavMenu.vue?vue&type=template&id=ab99ed04&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=ab99ed04&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1149623050/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab99ed04"]])

export default __exports__